<div class="tw-justify-center tw-items-center tw-gap-1 tw-inline-flex">
  <cohrex-button color="primaryLink" (click)="goToHome()">
    <div class="material-icons tw-text-[1.5rem] tw-relative tw-text-blue-800">
      home
    </div>
  </cohrex-button>
  @for (crumb of crumbs; track crumb; let last = $last; let first = $first) {
    @if (first) {
      <div class="material-icons tw-w-5 tw-h-5 tw-relative tw-text-blue-800">
        keyboard_arrow_right
      </div>
    }
    <cohrex-button
      color="primaryLink"
      [disabled]="!crumb.linkTo"
      [linkTo]="crumb.linkTo"
      (click)="handleNavigate(crumb.linkTo)"
      className="{{ disabled ? 'tw-bg-transparent !tw-text-zinc-500' : '' }}"
      ><b>{{ crumb.title | translate }}</b></cohrex-button
    >
    @if (!last) {
      <div class="material-icons tw-relative tw-text-blue-800 tw-mt-1">
        keyboard_arrow_right
      </div>
    }
  }
</div>
